import React from 'react';

const PrivacyPolicy = () => (
  <div className="max-w-2xl mx-auto p-8 text-gray-800">
    <h1 className="text-3xl font-bold mb-5">Privacy Policy</h1>
    <p className="mb-2">Last Updated: 29 Sep 2025</p>
    <h2 className="text-xl font-semibold mt-7 mb-2">1. Information We Collect</h2>
    <p>
      <strong>Personal Information:</strong> Name, email address, phone number, and other contact details when you fill out forms or subscribe to our services.<br />
      <strong>Usage Data:</strong> Information about how you use our website, including IP address, browser type, operating system, and browsing behavior.
    </p>
    <h2 className="text-xl font-semibold mt-7 mb-2">2. How We Use Your Information</h2>
    <ul className="mb-4 list-disc ml-5">
      <li>Provide and improve our services</li>
      <li>Respond to your inquiries and support needs</li>
      <li>Send you updates, marketing communications, and promotional offers</li>
      <li>Analyze website usage and trends</li>
    </ul>
    <h2 className="text-xl font-semibold mt-7 mb-2">3. Sharing Your Information</h2>
    <p>
      We do not sell, trade, or otherwise transfer your personal information to outside parties except as described below:
      <br /><strong>Service Providers:</strong> We may share information with third-party vendors who assist us in operating our website and conducting our business.<br />
      <strong>Legal Requirements:</strong> We may disclose your information if required by law or in response to valid requests by public authorities.
    </p>
    <h2 className="text-xl font-semibold mt-7 mb-2">4. Data Security</h2>
    <p>
      We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
    </p>
    <h2 className="text-xl font-semibold mt-7 mb-2">5. Cookies</h2>
    <p>
      Our website uses cookies to enhance your browsing experience. Cookies are small data files stored on your device. You can control the use of cookies through your browser settings.
    </p>
    <h2 className="text-xl font-semibold mt-7 mb-2">6. Third-Party Links</h2>
    <p>
      Our website may contain links to third-party websites. We are not responsible for the privacy practices of these websites. We encourage you to read their privacy policies.
    </p>
    <h2 className="text-xl font-semibold mt-7 mb-2">7. Your Rights</h2>
    <ul className="mb-4 list-disc ml-5">
      <li>Access, correct, or delete your personal information</li>
      <li>Withdraw consent for data processing</li>
      <li>Object to the processing of your data</li>
    </ul>
    <p>
      To exercise these rights, please contact us at <a href="mailto:contact@wetrnd.com" className="text-blue-600 underline">contact@wetrnd.com</a>.
    </p>
    <h2 className="text-xl font-semibold mt-7 mb-2">8. Changes to This Privacy Policy</h2>
    <p>
      We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on our website. Your continued use of the website after any changes signifies your acceptance of the new policy.
    </p>
    <h2 className="text-xl font-semibold mt-7 mb-2">9. Contact Us</h2>
    <address>
      WETRND<br />
      UNIT NO. A-120, AKSHAY MITTAL INDUSTRIAL ESTATE, A-WING, BUILDING NO.5B,<br />
      MAROL, ANDHERI (EAST), MUMBAI - 400059
    </address>
  </div>
);

export default PrivacyPolicy;
